// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Typography } from '@mui/material'
import Button from '@mui/material/Button'
import { gql } from 'graphql-tag'
import get from 'lodash/get'
import { inject } from 'mobx-react'
import moment from 'moment'
import React from 'react'
import { Query } from 'react-apollo'
import { Redirect, withRouter } from 'react-router-dom'
import Container from '../../common/container/Container'
import DateNav from '../../common/dateNav/DateNav'
import Loader from '../../common/loader/Loader'
import RestrictedView from '../auth/RestrictedView'
import Header from '../header/Header'
import { i18n } from '../index'
import css from './dailyInfo.css'
import DailyInfoForm from './DailyInfoForm'

const DAILY_INFO_QUERY = gql`
  query DailyInfoQuery($stationId: ID!, $date: String!, $mode: StaffPlanMode!) {
    staffPlan(stationId: $stationId, date: $date, mode: $mode) {
      id
      date
      roster {
        user {
          id
          name
        }
        startTime
        endTime
        startDateTime
        endDateTime
        position
        responsibility
        salesIncentiveTarget
        thumbsUpTarget
        note
      }
      date
    }
    dailyInfo(stationId: $stationId, date: $date) {
      id
      date
      allergyInfo {
        dishId
        dishName
        dishType
        lactoseFree
        glutenFree
        dairyFree
        vegan
      }
      allergyChecked
      otherInfo
      mealOptions {
        id
        name
        description
      }
    }
    reservations(stationId: $stationId, date: $date) {
      id
      startTime
      endTime
      name
      peopleCount
      otherInfo
      room
      contactName
      contactPhone
      paymentMethod
      reservationType
      mealOptionId
      mealOptionDescription
    }
  }
`
type Props = {
  edit: boolean
  match: any
  history: any
  stationStore: any
}
const DATE_FORMAT = 'YYYY-MM-DD'
const BASE_PATH = '/ravintolainfo'

@inject('stationStore')
class DailyInfo extends React.Component<Props> {
  getDate = () => {
    const { match } = this.props
    const date = get(match, 'params.date')

    // Default to current week, if params didn't have a week or it's in an invalid format.
    if (!date || !moment(date).isValid()) {
      return moment().format(DATE_FORMAT)
    }

    return date
  }
  getEditLink = () => {
    return `${BASE_PATH}/${this.getDate()}/muokkaa`
  }
  onCancel = () => {
    const { history } = this.props
    history.push(`${BASE_PATH}/${this.getDate()}`)
  }

  render() {
    const { edit, history, stationStore } = this.props
    const date = this.getDate()
    const stationId = stationStore.getActiveStationId()
    const mode = 'Day'
    return (
      <Query
        query={DAILY_INFO_QUERY}
        fetchPolicy='network-only'
        variables={{
          stationId,
          date,
          mode,
        }}
      >
        {({ data, loading, error }) => {
          const reservations = loading || error ? [] : get(data, 'reservations', [])
          const dailyInfo = loading || error ? null : get(data, 'dailyInfo', null)

          return (
            <div className={css.component}>
              <Header title={i18n.t('dailyInfo.header')} />
              <Container>
                <Typography variant='h6'>{i18n.t('dailyInfo.header')}</Typography>
                <RestrictedView requiredPermission='edit_dailyInfo'>
                  {(hasPermission) => (
                    <Loader loading={loading} error={error}>
                      {dailyInfo && !dailyInfo.id && !edit && hasPermission && <Redirect to={this.getEditLink()} />}
                      {edit && !hasPermission && <Redirect to={`${BASE_PATH}/${this.getDate()}`} />}
                      <div className={css.nav}>
                        <DateNav basePath={BASE_PATH} />
                      </div>
                      <div className={css.topBar}>
                        {!edit && hasPermission && (
                          <Button variant='contained' color='primary' onClick={() => history.push(this.getEditLink())}>
                            {i18n.t('buttons.edit')}
                          </Button>
                        )}
                      </div>
                      <DailyInfoForm
                        edit={edit}
                        date={date}
                        stationId={stationId}
                        dailyInfo={dailyInfo}
                        reservations={reservations}
                        onCancel={this.onCancel}
                      />
                    </Loader>
                  )}
                </RestrictedView>
              </Container>
            </div>
          )
        }}
      </Query>
    )
  }
}

export default withRouter(DailyInfo)
